/*
 * dawn-recommendations.js — `<product-recommendations>` (Dawn 15.4.1),
 * extrait de `global.js` en W-E. Chargé au point d'usage :
 * sections/related-products.liquid.
 */

(() => {

  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.controller = new AbortController();
      this.initializeRecommendations(this.dataset.productId);
    }

    /* W-E : Dawn n'avait aucun `disconnectedCallback` — l'IntersectionObserver et
       le fetch survivaient au retrait de la section (re-rendus d'éditeur). */
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = undefined;
      this.controller?.abort();
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      /* W-E (06·L11) : `response.ok` manquait — une 5xx injectait la page d'erreur. */
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`, {
        signal: this.controller?.signal,
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Section rendering: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((error) => {
          if (error?.name === 'AbortError') return;
          /* Bloc non critique : on laisse la section vide plutôt que d'écrire du HTML douteux. */
          this.classList.remove('product-recommendations--loaded');
        });
    }
  }

  if (customElements.get('product-recommendations') === undefined) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
